import React, { useCallback, useEffect, useRef, useState } from 'react';
import SubFilters from './SubFilters';
import { AppIcon } from '@common';
import { rightToggleIcon } from '@src/assets/svg';
import DateRangeModel from './DateRangeModel';
import '../style.scss';

const MenuItems = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [openLeft, setOpenLeft] = useState(false);
  const itemRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropDown = useCallback(() => {
    checkLocation();
    setDropdown((oldState) => !oldState);
  }, []);

  useEffect(() => {
    setTimeout(() => checkLocation(), 500);
  }, [props.state]);

  const checkLocation = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const isNearRightEdge = window.innerWidth - rect.right < 300; // Adjust 200px based on submenu width

      setOpenLeft(isNearRightEdge);
    }
  };

  useEffect(() => {
    const handler = (event) => {
      if (
        dropdown &&
        itemRef.current &&
        !itemRef.current.contains(event.target)
      ) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  return (
    <li className="dashboardFilters--dropdown--item" ref={itemRef}>
      {props.item.hasSubMenu ? (
        <>
          <button
            aria-expanded={dropdown.toString()}
            onClick={toggleDropDown}
            disabled={Object.entries(props.item.list).length === 0}
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
            className={`submenu-toggle ${openLeft ? 'left-align' : ''} ${
              Object.entries(props.item.list).length === 0 ? 'disabled' : ''
            }`}
            ref={buttonRef}
          >
            <span className="submenu-toggle--text">{props.item.title}</span>
            {props.depthLevel > 0 && (
              <AppIcon
                className="submenu-toggle--icon !text-[#2D9F75]"
                icon={rightToggleIcon}
              />
            )}
          </button>
          <SubFilters
            openLeft={openLeft}
            dropdown={dropdown}
            state={props.state}
            itemKey={props.item.key}
            item={props.item}
            dispatch={props.dispatch}
            toggleDropDown={toggleDropDown}
            handleState={props.handleState}
            depthLevel={props.depthLevel + 1}
          />
        </>
      ) : (
        <DateRangeModel handleDateSelection={props.handleDateSelection} />
      )}
    </li>
  );
};

export default MenuItems;
